import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-avatar-photo',
    templateUrl: './avatar-photo.component.html',
    styleUrls: ['./avatar-photo.component.scss'],
    standalone: false
})
export class AvatarPhotoComponent implements OnInit {

  @Input()
  public photoUrl: string;

  @Input()
  public name: string;

  public showInitials = false;
  public initials: string;
  public circleColor: string;

  private colors = [
      '#FF7E7E', // red
      '#9FD895', // green
      '#FFBF00', // yellow
      '#159CFA', // blue
  ];

  ngOnInit() {

      if (!this.photoUrl) {
          this.showInitials = true;
          this.createInititals();

          const randomIndex = Math.floor(Math.random() * Math.floor(this.colors.length));
          this.circleColor = this.colors[randomIndex];
      }

  }

  private createInititals(): void {
    let initials = "";

    const name_split = this.name.split(' ');
    if(name_split.length > 1 && name_split[1] !== '') {
        initials = name_split[0].charAt(0) + name_split[1].charAt(0);
    } else {
        // get the first 2 letters of the name
        initials = this.name.substring(0, 2);
    }

    this.initials = initials.toUpperCase();
  }

}
